export default "__VITE_ASSET__DpCP8g22__"